import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from 'data/reducers';
import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';
import ReactGA from 'react-ga';
import { getConfig } from 'config.js';

export const history = createHistory();
const routerHistory = routerMiddleware(history);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const analyticsId = getConfig('GA_ID');

ReactGA.initialize(analyticsId);

ReactGA.set({ page: history.location.pathname });
ReactGA.pageview(history.location.pathname);

history.listen((location, action) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
});

export function configureStore(initialState) {
    return createStore(
        rootReducer,
        initialState,
        composeEnhancers(applyMiddleware(thunk, routerHistory))
    );
}



// WEBPACK FOOTER //
// ./src/data/store/configureStore.js